import { render, staticRenderFns } from "./TableAnnualBudgetUpdater.vue?vue&type=template&id=dd504060&scoped=true"
import script from "./TableAnnualBudgetUpdater.vue?vue&type=script&lang=js"
export * from "./TableAnnualBudgetUpdater.vue?vue&type=script&lang=js"
import style0 from "./TableAnnualBudgetUpdater.vue?vue&type=style&index=0&id=dd504060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd504060",
  null
  
)

export default component.exports